import { corporationInformationsFormFieldsInitState } from '../../../styledComponents/Forms/CorporationInformationsForm/corporationInformationsForm.models';

export const initialValues = {
  ...corporationInformationsFormFieldsInitState,
  globalGuardianPoc: [{}],
  organizationPoc: [{}],
  organizationType: 'Corporation',
};
